import { Component } from 'react';
import request from "superagent";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import { login, setAuthStarted } from '@/actions/auth'
import { isAuthorizedAsGuest } from "@/selectors/auth";
import { setEmail } from "@v/member/actions/member";
import AuthCloseButton from "@v/auth/components/AuthCloseButton";
import Button from 'shared/Button';
import PropTypes from "prop-types";
import Translation from '@s/Translation';
import Spinner from "../../../../shared/Spinner";
import FanaticsSSO from "@v/auth/containers/FanaticsSSO";

class AuthContainer extends Component {

  state = {
    isLoaded: false,
    confirmationSent: false,
    hasError: false,
    providers: {}
  }

  loginProviderFanaticsId = 6;

  emailClick = () => {
    this.props.triggerTransition('authEmail', { referer: 'auth' });
    return false;
  }

  guestClick = () => {
    this.props.setEmail(null);
    this.props.login(''); // Authorize as guest with empty email
    if (this.props.token) {
      this.props.triggerTransition('checkout', {token: this.props.token});
    } else {
      this.props.triggerTransition('ticketPicker');
    }
    return false;
  }

  getProviders = () => {
    const url = this.props.ui.styleVars.GLOBAL__PARTNER__URL + '/sso/providers';
    return request.post(url)
      .set('Content-Type', 'application/json')
      .send(JSON.stringify({'partner': this.props.partner.partner_id}))
      .then(res => res.body);
  }

  verifyEmail = () => {
    this.setState({confirmationSent: true, isLoaded: true, hasError: false});
  }

  handleSSOLoading = () => {
    this.setState({ isLoaded: false });
  }

  handleSSOError = () => {
    this.setState({ hasError: true });
  }

  componentDidMount() {
    this.getProviders().then(providers => {
      this.props.setAuthStarted(true);
      this.setState({ providers: providers, isLoaded: true });
    });
  }

  render() {
    return (
        <dialog
          className="tickets--as-overlay tickets-wrap"
          aria-modal="true"
          aria-labelledby="presale-coupon-desc">
          <div className="tickets">
            <div className="checkout-sso__main-header">
              <div className="checkout-sso__logo-container">
                <img className="checkout-sso__header-image" src={this.props.partner.logo} alt={''}/>
              </div>
              {<AuthCloseButton />}
            </div>
            <div className="tickets__content checkout-sso__content">
              {!this.state.hasError && !this.state.confirmationSent &&
                <div>
                  <div className="checkout-sso__header">
                    <Translation>{'checkout__sign_in_to_continue_purchase'}</Translation>
                  </div>
                  <div className='text-center'>
                    {this.state.isLoaded && <div>
                      {Object.entries(this.state.providers).map(([key, value]) =>
                        value.type === this.loginProviderFanaticsId
                          ? <FanaticsSSO key={key}
                                         handleEmailVerification={this.verifyEmail}
                                         handleSSOLoading={this.handleSSOLoading}
                                         handleSSOError={this.handleSSOError}/>
                          : null
                      )}
                      {this.props.emailCheckoutEnabled && <div>
                        <Button onClick={this.emailClick} className="button--secondary button--sso">
                          <i className="icon-markunread checkout-sso__sso_icon"></i>
                          <span><Translation>{'checkout__continue_with_email'}</Translation></span>
                        </Button>
                      </div>}
                      {this.props.guestCheckoutEnabled && <div>
                        <Button onClick={this.guestClick} className="button--secondary button--sso">
                          <span><Translation>{'checkout__continue_as_guest'}</Translation></span>
                        </Button>
                      </div>}
                    </div>}
                    {!this.state.isLoaded && <div className="inline-block"><Spinner/></div>}
                  </div>
                </div>}
              {this.state.confirmationSent && <div>
                <div className="checkout-sso__header">
                  <Translation>{'checkout__verification_link_sent'}</Translation>
                </div>
              </div>}
              {this.state.hasError && <div>
                <div className="checkout-sso__header">
                  <Translation>{'Checkout__reservation_error'}</Translation>
                </div>
              </div>}
            </div>
          </div>
        </dialog>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    authorisedAsGuest: isAuthorizedAsGuest(state),
    partner: state.partner,
    token: state.reservation.token,
    emailCheckoutEnabled: state.settings.emailCheckoutEnabled,
    guestCheckoutEnabled: state.settings.guestCheckoutEnabled,
    ui: state.ui
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    login,
    setAuthStarted,
    setEmail,
    triggerTransition
  }, dispatch);
};

AuthContainer.propTypes = {
  emailCheckoutEnabled: PropTypes.bool.isRequired,
  guestCheckoutEnabled: PropTypes.bool.isRequired,
  partner: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  ui: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthContainer)
